import React, { useState } from 'react';
import { MoveHorizontalIcon } from 'lucide-react';
interface BeforeAfterProps {
  beforeImage: string;
  beforeAlt: string;
  afterImage: string;
  afterAlt: string;
}
export function BeforeAfter({
  beforeImage,
  beforeAlt,
  afterImage,
  afterAlt
}: BeforeAfterProps) {
  const [position, setPosition] = useState(50);
  return <figure data-id="element-139" data-mp="3qmwdiw7e3jvw">
      <div className="relative overflow-hidden rounded-card border border-hairline bg-surface" data-id="element-140" data-mp="3qneich84b6ff">
        <div className="relative aspect-[16/10] w-full" data-id="element-141" data-mp="r5eyxfjdksml">
          <img src={afterImage} alt={afterAlt} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover object-top" data-id="element-142" data-mp="n4cwyqy2q2gx" />
          <div className="absolute inset-0" style={{
          clipPath: `inset(0 ${100 - position}% 0 0)`
        }} data-id="element-143" data-mp="de0ceyq9e9as">
            <img src={beforeImage} alt={beforeAlt} loading="lazy" decoding="async" className="h-full w-full object-cover object-top" data-id="element-144" data-mp="1aw0g2mp3g98n" />
          </div>

          <span aria-hidden="true" className="absolute inset-y-0 w-px bg-white" style={{
          left: `${position}%`
        }} data-id="element-145" data-mp="2fomacamfhytg" />
          <span aria-hidden="true" className="absolute top-1/2 flex h-9 w-9 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-hairline bg-white text-ink shadow-[0_4px_12px_rgba(14,14,14,0.18)]" style={{
          left: `${position}%`
        }} data-id="element-146" data-mp="21uv8loexvj8a">
            <MoveHorizontalIcon size={16} data-id="element-147" data-mp="1ixtsb7fxpwp1" />
          </span>

          <span className="absolute bottom-4 left-4 rounded-full bg-ink/85 px-3 py-1 text-[12px] font-medium text-white" data-id="element-148" data-mp="1izeo10dzjloh">
            Assumed starting point
          </span>
          <span className="absolute bottom-4 right-4 rounded-full bg-white/90 px-3 py-1 text-[12px] font-medium text-ink" data-id="element-149" data-mp="3dcwd4ru1gqlm">
            Concept direction
          </span>
        </div>

        <label className="block border-t border-hairline px-5 py-4" data-id="element-150" data-mp="u5ik4ysd0d8o">
          <span className="text-small text-muted" data-id="element-151" data-mp="p5w46hl5ciw6">Drag to compare</span>
          <input type="range" min={0} max={100} value={position} onChange={event => setPosition(Number(event.target.value))} aria-label="Reveal the assumed starting point" className="mt-3 h-1 w-full cursor-ew-resize appearance-none rounded-full bg-hairline outline-none accent-ink focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2" data-id="element-152" data-mp="p4kzmfjvn740" />
        </label>
      </div>
      <figcaption className="mt-4 text-[13px] leading-6 text-[#6E6E6E]" data-id="element-153" data-mp="141vkugmbnrcx">
        Illustrative comparison — self-initiated concept.
      </figcaption>
    </figure>;
}